import { useState, useCallback } from "react";
import {Consts} from "../components/pages/consts";
import {useTranslation} from "react-i18next";

export const useHttp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const buildOptions = (method, headers, body, isUpload) => {
    let options = {
      method: method,
      headers: headers,
    };

    if (body) {
      if (isUpload) {
        options = { ...options, body: body };
      } else {
        options = { ...options, body: JSON.stringify(body) };
      }
    }

    return options;
  };

  const request = useCallback(
    async (
      url,
      method = Consts.GET,
      body = null,
      headers = { "Content-Type": Consts.APPLICATION_JSON },
      isBlob = false, // it is true for downloaded files
    ) => {
      setLoading(true);

      const options = buildOptions(
        method,
        headers,
        body,
        url?.indexOf(Consts.UPLOAD) > 0 || url?.indexOf("precisionDosing/order/finish") > 0,
      );

      try {
        const response = await fetch(url, options);

        if (isBlob) { // it is for downloaded files
          const blob = await response.blob();
          setLoading(false);
          const disposition = response.headers?.get("Content-Disposition");
          let filename = "downloaded_file";

          if (disposition && disposition?.indexOf(Consts.ATTACHMENT) !== -1) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
                disposition,
            );

            if (matches != null && matches[1]) {
              filename = matches[1]?.replace(/['"]/g, "");
            }
          }

          return { blob, filename };
        }

        const responseJson = await response.json();
        setLoading(false);
        const { mmc_status_code, mmc_status_msg, mmc_payload } = responseJson;

        if (mmc_status_code && mmc_status_code > 201) {
          throw new Error(
            mmc_status_msg ? mmc_status_msg : `${mmc_status_code} ${t("happened")}`,
          );
        }

        return mmc_payload ? mmc_payload : responseJson;
      } catch (e) {
        setLoading(false);
        setError(e.message);
      }
    },
    [],
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    loading,
    request,
    error,
    clearError,
  };
};
